import React from "react";

const ValueRow = ({ className, title, columns, background = "#d6ece9" }) => (
  <div className={`value-row ${className}`} style={{ backgroundColor: background }}>
    <span className="item title">{title}</span>
    {columns.map((column, idx) => (
      <span key={idx} className="item">{column}</span>
    ))}
  </div>
);

export default ValueRow;
